/**
 * Mijn profiel — zelfde layout als /admin/settings?tab=users (AdminHub met
 * secundaire sidebar) en met ?tab= in de URL (deep-linkbaar). Corvee is een sectie.
 */
import React from "react";
import { Box } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { useSearchParams } from "react-router-dom";
import PageHeader from "../../ui-components/PageHeader";
import AdminHub from "../AdminSettings/AdminHub";
import { SectionHeader } from "../AdminSettings/adminSettingsCommon";
import CorveeMemberPanel from "../Corvee/CorveeMemberPanel";
import AgendaBlokkenPanel from "./AgendaBlokkenPanel";
import MeldingenPanel from "./MeldingenPanel";

function CorveeSection() {
  const { instance } = useMsal();
  const email = instance.getActiveAccount()?.username || "";
  return (
    <Box>
      <SectionHeader
        title="Corvee-beschikbaarheid"
        subtitle="Je standaard werkdagen komen uit het personeelsbestand (vrije dagen staan vast). Stel per even/oneven week in of je op kantoor of thuis werkt. Dit is de terugval wanneer je een corveeweek niet zelf invult. Onderaan zie je je corvee-credits."
      />
      <CorveeMemberPanel email={email} showCredits />
    </Box>
  );
}

function AgendaSection() {
  return (
    <Box>
      <SectionHeader
        title="Taken in je agenda"
        subtitle="Zet je ingeplande taken als blokken in je eigen Outlook-agenda, tussen je bestaande afspraken. Jij bepaalt of dit aan staat."
      />
      <AgendaBlokkenPanel />
    </Box>
  );
}

function MeldingenSection() {
  return (
    <Box>
      <SectionHeader
        title="Meldingen"
        subtitle="Welke automatische mails en meldingen je van intern wilt krijgen. Standaard staat alles aan; hier zet je het per soort uit."
      />
      <MeldingenPanel />
    </Box>
  );
}

const SECTIONS = [
  { key: "corvee", label: "Corvee", icon: "cleaning_services", accent: { color: "#635983", bg: "#dbcdff" }, component: CorveeSection },
  { key: "agenda", label: "Taken in je agenda", icon: "event_available", accent: { color: "#0e7490", bg: "#cffafe" }, component: AgendaSection },
  { key: "meldingen", label: "Meldingen", icon: "notifications_active", accent: { color: "#b45309", bg: "#fef3c7" }, component: MeldingenSection },
];

export default function MijnProfiel() {
  const { instance } = useMsal();
  const acc = instance.getActiveAccount();
  const name = acc?.name || "Gebruiker";
  const email = acc?.username || "";
  const [searchParams, setSearchParams] = useSearchParams();
  const activeKey = searchParams.get("tab") || "corvee";
  const onSelect = (key) => setSearchParams(key ? { tab: key } : {});

  return (
    <Box sx={{ width: "100%", px: { xs: 2, sm: 3, md: 5 }, pt: { xs: 3, md: 5 }, pb: 10 }}>
      <PageHeader icon="badge" title="Mijn profiel" subtitle={`${name}${email ? ` · ${email}` : ""}`} accent={{ bg: "#dbcdff", color: "#635983" }} />
      <AdminHub title="Mijn profiel" subtitle="Persoonlijke instellingen" sections={SECTIONS} activeKey={activeKey} onSelect={onSelect} />
    </Box>
  );
}
